var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dialogCover",
    style: {
      width: _vm.pageWidth + 'px',
      height: _vm.pageHeight + 'px'
    },
    on: {
      "click": _vm.dialogCoverClick
    }
  }, [_c('div', {
    staticClass: "dialogMain"
  }, [_c('div', {
    staticClass: "dialogMainTitle"
  }, [_vm._v("话术移动至")]), _c('div', {
    staticClass: "dialogMainContent"
  }, [_c('div', {
    staticClass: "dialogMainContentL"
  }, [_vm._v("选择分类")]), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "btnBar"
  }, [_c('div', {
    staticClass: "btnBarL",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 取消 ")]), _c('div', {
    staticClass: "btnBarR",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" 保存 ")])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };